import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable, Injector} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../services/toast.service';

@Injectable()
export class BusinessRuleInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const translateService = this.injector.get(TranslateService);
        const toastService = this.injector.get(ToastService);
        if (error.status === 429) {
          toastService.showMessage({
            severity: 'error',
            summary: "Error 429 To many requests",
            detail: "Contact developer",
          });
        }
        if (error.status === 422) {
          const errorCode: string | undefined = error.error?.errorCode;
          const key = errorCode ? `business-rule.${errorCode}` : 'business-rule.UNKNOWN';
          const translated = translateService.instant(key);
          toastService.showMessage({
            severity: 'error',
            summary: translateService.instant('business-rule.title'),
            // instant() renvoie la clé telle quelle quand la traduction n'existe pas
            detail: translated === key ? translateService.instant('generic-error.detail') : translated,
          });
        }
        return throwError(() => error);
      })
    );
  }
}
